<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 顶部门店选择（公告按门店分组，默认第一个门店=总店） -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="storeId" placeholder="请选择门店" @change="onStoreChange">
                    <a-select-option v-for="s in storeOptionList" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="section-title">公告管理</div>
        <!-- 操作按钮区域（克隆云贝 #/storenoticeset"新增公告"） -->
        <div class="table-operator">
          <a-button type="primary" icon="plus" @click="handleAdd">新增公告</a-button>
        </div>
        <!-- table区域 -->
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          @change="handleTableChange">
          <template slot="typeSlot" slot-scope="text, record">
            <a-tag v-if="String(record.noticeType) === '1'" color="green">前台公告</a-tag>
            <a-tag v-else color="orange">后台公告</a-tag>
          </template>
          <template slot="displaySlot" slot-scope="text, record">
            <a-switch
              :checked="String(record.display) === '1'"
              checkedChildren="显示"
              unCheckedChildren="隐藏"
              @change="checked => onDisplayChange(record, checked)" />
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="handleDelete(record)">删除</a>
          </span>
        </a-table>
        <!-- ============ 公告编辑弹窗（克隆云贝：排序/公告类型/公告标题/公告简介/公告详情/显示状态） ============ -->
        <a-modal
          :title="dialogTitle"
          :width="700"
          :visible="dialogVisible"
          :confirmLoading="confirmLoading"
          :maskClosable="false"
          @ok="handleModalOk"
          @cancel="dialogVisible = false"
          cancelText="取 消"
          okText="确 定"
          style="top:120px;">
          <a-form class="notice-form">
            <a-form-item label="排序" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
              <a-input v-model="noticeForm.sort" type="number" placeholder="请输入排序" style="width: 200px" />
            </a-form-item>
            <a-form-item label="公告类型" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" required>
              <a-radio-group v-model="noticeForm.noticeType">
                <a-radio value="1">前台公告</a-radio>
                <a-radio value="2">后台公告</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="公告标题" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" required>
              <a-input v-model="noticeForm.title" autocomplete="off" placeholder="请输入公告标题" style="width: 460px" />
            </a-form-item>
            <a-form-item label="公告简介" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
              <a-textarea v-model="noticeForm.introduction" placeholder="请输入公告简介" :rows="2" />
            </a-form-item>
            <a-form-item label="公告详情" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
              <a-textarea v-model="noticeForm.body" placeholder="请输入公告详情" :rows="6" />
            </a-form-item>
            <a-form-item label="显示状态" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
              <a-switch
                :checked="String(noticeForm.display) === '1'"
                checkedChildren="显示"
                unCheckedChildren="隐藏"
                @change="checked => onFormDisplayChange(checked)" />
            </a-form-item>
          </a-form>
        </a-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { getAction, postAction, putAction, deleteAction } from '@/api/manage'
import { storeOptions } from '@/api/plugin/dining'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mixinDevice } from '@/utils/mixin'

/**
 * 门店公告页（完全克隆云贝 #/storenoticeset）
 * API 契约（Task 2A 另一代理实现中）：
 *   GET    /api/plugin/dining/notices?page&pageSize&storeId
 *   POST   /api/plugin/dining/notices（新增）
 *   PUT    /api/plugin/dining/notices/{id}（编辑）
 *   DELETE /api/plugin/dining/notices/{id}
 *   PUT    /api/plugin/dining/notices/{id}/display（body {display:'1'|'2'}）
 * 前台公告（notice_type=1 且 display=1）→ 小程序点餐页公告条轮播展示（Task 2B.6 小程序侧接入）
 * 菜单挂载：菜单 SQL 后续统一出（url 建议 /plugin/dining/notice）
 */
const NOTICE_PREFIX = '/api/plugin/dining/notices'

// 公告表单默认值（云贝 data 同款：sort '1'、noticeType '1'）
const NOTICE_DEFAULTS = {
  sort: '1',
  noticeType: '1',
  title: '',
  introduction: '',
  body: '',
  display: '1'
}

export default {
  name: 'DiningNoticeList',
  mixins: [JeecgListMixin, mixinDevice],
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      queryParam: {},
      storeOptionList: [],
      storeId: null,
      dialogTitle: '添加',
      dialogVisible: false,
      confirmLoading: false,
      noticeForm: Object.assign({}, NOTICE_DEFAULTS),
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200']
      },
      columns: [
        { title: '排序', dataIndex: 'sort', width: 80, align: 'center' },
        { title: '公告标题', dataIndex: 'title', align: 'left' },
        { title: '发布时间', dataIndex: 'createdAt', width: 160, align: 'center', customRender: t => t || '-' },
        { title: '公告类型', dataIndex: 'noticeType', width: 110, align: 'center', scopedSlots: { customRender: 'typeSlot' } },
        { title: '显示状态', dataIndex: 'display', width: 100, align: 'center', scopedSlots: { customRender: 'displaySlot' } },
        { title: '操作', dataIndex: 'action', width: 120, align: 'center', scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadStores()
  },
  methods: {
    loadStores() {
      const that = this
      storeOptions().then(res => {
        if (res.code === 200) {
          that.storeOptionList = res.data || []
          if (that.storeOptionList.length) {
            // 默认第一个门店（options 总店在首位）
            that.storeId = that.storeOptionList[0].id
            that.loadData(1)
          }
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    onStoreChange() {
      this.loadData(1)
    },
    // 后端契约：GET /notices?page&pageSize&storeId，覆写 mixin 的 loadData
    loadData(arg) {
      if (!this.storeId) {
        return
      }
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      const params = {
        page: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        storeId: this.storeId
      }
      getAction(NOTICE_PREFIX, params).then(res => {
        if (res.code === 200) {
          this.dataSource = res.data.rows || []
          this.ipagination.total = res.data.total || 0
        } else {
          this.$message.warning(res.message)
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 显示状态切换（契约：PUT /notices/{id}/display）
    onDisplayChange(record, checked) {
      const that = this
      putAction(`${NOTICE_PREFIX}/${record.id}/display`, { display: checked ? '1' : '2' }).then(res => {
        if (res.code === 200) {
          that.$message.success('保存成功')
        } else {
          that.$message.warning(res.message)
        }
        that.loadData()
      })
    },
    onFormDisplayChange(checked) {
      this.noticeForm.display = checked ? '1' : '2'
    },
    // 新增公告（title="添加"，云贝同款）
    handleAdd() {
      this.noticeForm = Object.assign({}, NOTICE_DEFAULTS)
      this.dialogTitle = '添加'
      this.dialogVisible = true
    },
    // 编辑公告（title="编辑"）
    handleEdit(record) {
      this.noticeForm = Object.assign({}, NOTICE_DEFAULTS, record)
      this.dialogTitle = '编辑'
      this.dialogVisible = true
    },
    handleModalOk() {
      const that = this
      const form = this.noticeForm
      if (!form.title || !String(form.title).trim()) {
        this.$message.warning('请输入公告标题')
        return
      }
      const body = {
        storeId: this.storeId,
        sort: form.sort,
        noticeType: form.noticeType,
        title: String(form.title).trim(),
        introduction: form.introduction,
        body: form.body,
        display: form.display
      }
      this.confirmLoading = true
      let request
      if (form.id) {
        request = putAction(`${NOTICE_PREFIX}/${form.id}`, body)
      } else {
        request = postAction(NOTICE_PREFIX, body)
      }
      request.then(res => {
        if (res.code === 200) {
          that.$message.success(res.message || '保存成功')
          that.dialogVisible = false
          that.loadData()
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.confirmLoading = false
      })
    },
    // 删除公告（确认文案照抄云贝"你确定要删除当前项吗"）
    handleDelete(record) {
      const that = this
      this.$confirm({
        title: '删除确认',
        content: '你确定要删除当前项吗',
        onOk() {
          return deleteAction(`${NOTICE_PREFIX}/${record.id}`).then(res => {
            if (res.code === 200) {
              that.$message.success(res.message || '删除成功')
              that.loadData()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.section-title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 10px;
  border-left: 3px solid #1890ff;
  margin: 8px 0 12px;
}
.notice-form {
  max-width: 640px;
}
</style>
